import { createRouter, createWebHistory, RouteRecordRaw} from 'vue-router';
import SecurityService from "./service/SecurityService";
// import questionRoutes from "./module/question/QuestionRouter";

const otherRoutesChildren: RouteRecordRaw[] = [
    // Security Routes - matching codereadr-node route names exactly

    // Existing routes
    { path: '/home', name: 'home', component: () => import('./page/home/IndexPage.vue'), meta: { authenticate: false,  title: 'Smart Barcode Scanner App for Businesses - CodeREADr' } },
    { path: '/about', name: 'about', component: () => import('./page/AboutPage.vue'), meta: { authenticate: false,  title: 'Smart Barcode Scanner App for Businesses - CodeREADr' } },
    { path: 'apidocs/:pageName?', name: 'apidoc', component: () => import('./page/apiDocs/IndexPage.vue'), meta: { authenticate: false,  title: 'Embed codeREADr into your own application' } },
    { path: 'aayor/', name:'aayor', component: () => import('./page/portal/AayorRedirectPage.vue'), meta: { authenticate: false } },
    { path: 'limitreached/', name:'app.limitreached', component: () => import('./page/apiCallLimit/IndexPage.vue'), meta: { authenticate: false, title: 'LimitReached' } },
    { path: 'account/pickinterests/', name:'app.pickinterests', component: () => import('./page/pickInterests/IndexPage.vue'), meta: { authenticate: true ,  title: 'Pick Interests'}},
    { path: 'unauthorized/', name:'app.unauthorized', component: () => import('./page/unauthorized.vue'), meta: { authenticate: true, title: 'Unauthorized' } },
    { path: 'account/firstlogin/', name:'app.firstlogin', component: () => import('./page/firstLogin/IndexPage.vue'), meta: { authenticate: true } },
    { path: 'maintenance/', name:'app.maintenance', component: () => import('./page/maintenance/IndexPage.vue'), meta: { authenticate: false, title: 'Maintenance' } },
    { path: '/app/1.0/more/apphelp', name: 'app.help', component: () => import('./page/help/IndexPage.vue'), meta: { authenticate: false, title: 'codeREADr Help' }},
    {
        path: 'account/services/', name: 'account.service', component: () => import('./page/service/ServiceIndexPage.vue'), meta: {title: 'Services', authenticate: true, admin: true}, children: [
            { path: 'pre-create/', name: 'account.service.precreate', component: () => import('./page/service/PreCreatePage.vue'), meta: {authenticate: true },
                props: (route) => ({preview: route.query.preview,}),
            },
            { path: 'new/:serviceType?', name: 'account.service.create', component: () => import('./page/service/CreatePage.vue'), meta: {authenticate: true },
                props: (route) => ({preview: route.query.preview,}),
            },
            {
                path: 'create-demo/', name: 'account.service.createdemo', component: () => import('./page/service/CreateDemoPage.vue'), meta: {authenticate: true}
            },
            { path: '', name: 'account.service.index', component: () => import('./page/service/ServiceListPage.vue'), meta: {authenticate: true },
                props: (route) => ({
                    page: route.query.page,
                    limit: route.query.limit,
                    search: route.query.search,
                    sortby: route.query.sortby,
                    servicetype: route.query.servicetype,
                    sortdirection: route.query.sortdirection
                }),
            },
            {
                path: ':serviceId/',
                name: 'account.service.edit',
                component: () => import('./page/service/EditPage.vue'),
                meta: {authenticate: true},
                props: (route) => ({preview: route.query.preview}),
                children: [
                    { path: 'type/', name: 'account.service.edit.type', component: () => import('./page/service/EditTypePage.vue'), meta: {authenticate: true } },
                    { path: 'users/', name: 'account.service.edit.users', component: () => import('./page/service/EditUsersPage.vue'), meta: {authenticate: true } },
                    { path: 'questions/', name: 'account.service.edit.questions', component: () => import('./page/service/EditQuestionsPage.vue'), meta: {authenticate: true } },
                    { path: 'advanced/', name: 'account.service.edit.advanced', component: () => import('./page/service/EditAdvancedPage.vue'), meta: {authenticate: true } },
                    // { path: 'decoder/', name: 'account.service.edit.decoder', component: AppServiceEditDecoderPage, meta: {authenticate: true } },
                    { path: 'done/', name: 'account.service.edit.done', component: () => import('./page/service/EditDonePage.vue'), meta: {authenticate: true } },
                    // { path: 'checklist/', name: 'account.service.edit.checklist', component: AppServiceEditChecklistPage, meta: {authenticate: true } },

                ]
            }
        ]
    },
    {
        path: 'account/specialized-services/',
        alias: 'account/curated-services',
        name: 'account.curated',
        component: () => import('./page/curatedService/ServicePage.vue'), meta: { title: 'Specialized Services', authenticate: true },
        children: [

            { path: 'create/', name: 'account.curated.create', component: () => import('./page/curatedService/CreatePage.vue'), meta: { authenticate: true},
                children: [
                    { path: 'table-builder/', name: 'account.curated.create.scandbbuilder', component: () => import('./page/curatedService/tableBuilder/CreatePage.vue'), meta: {title: 'Table Builder', authenticate: true} },
                    { path: 'check-in-out/', name: 'account.curated.create.checkinout', component: () => import('./page/curatedService/checkInOut/CreatePage.vue'), meta: {title: 'Check In/Out', authenticate: true} },
                    { path: 'logistics/', name: 'account.curated.create.logistics', component: () => import('./page/curatedService/logistics/CreatePage.vue'), meta: {title: 'Logistics', authenticate: true} },
                    { path: 'ab-barcode-matching/', name: 'account.curated.create.abbarcodematching', component: () => import('./page/curatedService/AbBarcodeMatching/CreatePage.vue'), meta: {title: 'A/B Barcode Matching', authenticate: true} },
                    { path: 'attendance/', name: 'account.curated.create.attendance', component: () => import('./page/curatedService/Attendance/CreatePage.vue'), meta: {title: 'Attendance', authenticate: true} },
                    { path: 'scan-tickets/', name: 'account.curated.create.scantickets', component: () => import('./page/curatedService/scanTicketing/CreatePage.vue'), meta: { title: 'Scan Tickets', authenticate: true } },
                    { path: 'scan-to-excel/', name: 'account.curated.create.scantoexcelsheets', component: () => import('./page/curatedService/ScanToExcelSheets/CreatePage.vue'), meta: {title: 'Scan To Excel Sheets', authenticate: true} },
                ]
            },
            { path: ':instanceId/', name: 'account.curated.edit', component: () => import('./page/curatedService/EditPage.vue'),  meta: {authenticate: true} ,
                children: [
                    { path: 'logistics/', name: 'account.curated.edit.logistics', component: () => import('./page/curatedService/logistics/EditPage.vue'), meta: {title: 'Logistics', authenticate: true} },
                    { path: 'attendance/', name: 'account.curated.edit.attendance', component: () => import('./page/curatedService/Attendance/EditPage.vue'), meta: {title: 'Attendance', authenticate: true} },
                    { path: 'scan-tickets/', name: 'account.curated.edit.scantickets', component: () => import('./page/curatedService/scanTicketing/EditPage.vue'), redirect: {name: 'account.curated.edit.scantickets.database'}, meta: { title: 'Scan Tickets', authenticate: true },
                        children: [
                            { path: 'details/', name: 'account.curated.edit.scantickets.details', component: () => import('./page/curatedService/scanTicketing/EditDetailPage.vue'), meta: { authenticate: true }
                            },
                            { path: 'database/', name: 'account.curated.edit.scantickets.database', component: () => import('./page/curatedService/scanTicketing/EditDatabasePage.vue'), meta: { authenticate: true }
                            },
                            { path: 'history/', name: 'account.curated.edit.scantickets.history', component: () => import('./page/curatedService/scanTicketing/EditScanHistoryPage.vue'), meta: { authenticate: true }
                            },
                            { path: 'users/', name: 'account.curated.edit.scantickets.users', component: () => import('./page/curatedService/scanTicketing/EditUserPage.vue'), meta: { authenticate: true }
                            }
                        ]
                    },
                    { path: 'scan-to-excel/', name: 'account.curated.edit.scantoexcelsheets', component: () => import('./page/curatedService/ScanToExcelSheets/EditPage.vue'), redirect: {name: 'account.curated.edit.scantoexcelsheets.tableview'}, meta: {title: 'Scan To Excel',authenticate: true},
                        children: [
                            { path: 'table-view/', name: 'account.curated.edit.scantoexcelsheets.tableview', component: () => import('./page/curatedService/ScanToExcelSheets/TableView.vue'), meta: { authenticate: true }
                            },
                            { path: 'details/', name: 'account.curated.edit.scantoexcelsheets.details', component: () => import('./page/curatedService/ScanToExcelSheets/EditDetails.vue'), meta: { authenticate: true }
                            },
                            { path: 'users/', name: 'account.curated.edit.scantoexcelsheets.users', component: () => import('./page/curatedService/ScanToExcelSheets/EditUsers.vue'), meta: { authenticate: true }},
                        ]
                    },
                    { path: 'table-builder/', name: 'account.curated.edit.scandbbuilder', component: () => import('./page/curatedService/tableBuilder/EditPage.vue'), redirect: {name: 'account.curated.edit.scandbbuilder.details'}, meta: {title: 'Table Builder',authenticate: true},
                        children: [
                            { path: 'details/', name: 'account.curated.edit.scandbbuilder.details', component: () => import('./page/curatedService/tableBuilder/EditDetailPage.vue'), meta: { authenticate: true }
                            },
                            { path: 'tableview/', name: 'account.curated.edit.scandbbuilder.tableview', component: () => import('./page/curatedService/tableBuilder/EditTableViewPage.vue'), meta: { authenticate: true }},

                            { path: 'users/', name: 'account.curated.edit.scandbbuilder.users', component: () => import('./page/curatedService/tableBuilder/EditUserPage.vue'), meta: { authenticate: true }
                            },
                            { path: 'questions/', name: 'account.curated.edit.scandbbuilder.questions', component: () => import('./page/curatedService/tableBuilder/EditQuestionPage.vue') , meta: { authenticate: true }
                            },
                            { path: 'shareurl/', name: 'account.curated.edit.scandbbuilder.shareurl', component: () => import('./page/curatedService/tableBuilder/EditShareUrlPage.vue'), meta: { authenticate: true }
                            },
                            { path: 'advanced/', name: 'account.curated.edit.scandbbuilder.advanced', component: () => import('./page/curatedService/tableBuilder/EditAdvancedPage.vue'), meta: { authenticate: true }
                            },
                        ]
                    },

                    { path: 'check-in-out/', name: 'account.curated.edit.checkinout', component: () => import('./page/curatedService/checkInOut/EditPage.vue'), redirect: {name: 'account.curated.edit.checkinout.details'}, meta: {authenticate: true, title: 'Check In/Out'},
                        children: [
                            { path: 'details/', name: 'account.curated.edit.checkinout.details', component: () => import('./page/curatedService/checkInOut/EditDetailPage.vue'), meta: { authenticate: true, title: 'Check In/Out' }
                            },
                            { path: 'checklist/', name: 'account.curated.edit.checkinout.checklist', component: () => import('./page/curatedService/checkInOut/EditChecklistPage.vue'), meta: { authenticate: true }
                            },
                            { path: 'users/', name: 'account.curated.edit.checkinout.users', component: () => import('./page/curatedService/checkInOut/EditUserPage.vue'), meta: { authenticate: true }
                            },
                            { path: 'questions/', name: 'account.curated.edit.checkinout.questions', component: () => import('./page/curatedService/checkInOut/EditQuestionPage.vue') , meta: { authenticate: true }
                            },
                            { path: 'advanced/', name: 'account.curated.edit.checkinout.advanced', component: () => import('./page/curatedService/checkInOut/EditAdvancedPage.vue'), meta: { authenticate: true }
                            },
                        ]
                    },

                    { path: 'ab-barcode-matching/', name: 'account.curated.edit.abbarcodematching', component: () => import('./page/curatedService/AbBarcodeMatching/EditPage.vue'),  meta: { title: 'A/B Barcode Matching', authenticate: true }, redirect: {name: 'account.curated.edit.abbarcodematching.type'},
                        children: [
                            {
                                path: 'type/',
                                name: 'account.curated.edit.abbarcodematching.type',
                                component: () => import('./page/curatedService/AbBarcodeMatching/EditTypePage.vue'),
                                meta: {authenticate: true}
                            },
                            {
                                path: 'users/',
                                name: 'account.curated.edit.abbarcodematching.users',
                                component: () => import('./page/curatedService/AbBarcodeMatching/EditUserPage.vue'),
                                meta: {authenticate: true}
                            },
                            {
                                path: 'questions/',
                                name: 'account.curated.edit.abbarcodematching.questions',
                                component: () => import('./page/curatedService/AbBarcodeMatching/EditQuestionPage.vue'),
                                meta: {authenticate: true}
                            },
                            {
                                path: 'advanced/',
                                name: 'account.curated.edit.abbarcodematching.advanced',
                                component: () => import('./page/curatedService/AbBarcodeMatching/EditAdvancedPage.vue'),
                                meta: {authenticate: true}
                            }

                        ]

                    }
                ]
            },
        ]
    },
    {
        path: 'account/scans/', name: 'account.scans', component: () => import('./page/scan/IndexPage.vue'), redirect: '/account/scans/search', meta: {authenticate: true, admin: true}, children: [
            { path: 'search/', name: 'account.scans.search', component: () => import('./page/scan/search/IndexPage.vue'),redirect: '/account/scans/search/full', meta: {title: 'Scans', authenticate: true },
                props: (route) => ({
                    page: route.query.page, limit: route.query.limit, value: route.query.value, exact_value: route.query.exact_value, value_ci: route.query.value_ci,
                    response: route.query.response, response_ci: route.query.response_ci, exact_response: route.query.exact_response, property_name: route.query.property_name,
                    property_value: route.query.property_value, scan_ids: route.query.scan_ids, answer: route.query.answer, exact_answer: route.query.exact_answer,
                    recent_scan: route.query.recent_scan, property: route.query.property, exact_property: route.query.exact_property, data_received: route.query.data_received,
                    sort_order: route.query.sort_order, tz: route.query.tz, period: route.query.period, p_metric: route.query.p_metric, p_number: route.query.p_number,
                    sort_by: route.query.sort_by, category: route.query.category, result: route.query.result, start_date: route.query.start_date, start_time: route.query.start_time,
                    end_date: route.query.end_date, end_time: route.query.end_time, service_ids: route.query.service_ids, user_ids: route.query.user_ids, device_ids: route.query.device_ids,
                    u_deleted: route.query.u_deleted, s_deleted: route.query.s_deleted, template: route.query.template, preview: route.query.preview
                }),
                children: [
                    { path: 'full/', name: 'account.scans.search.full', component: () => import('./page/scan/search/FullPage.vue'), meta: {title: 'Full View', authenticate: true }, props: true},
                    { path: 'list/', name: 'account.scans.search.list', component: () => import('./page/scan/search/ListPage.vue'), meta: {title: 'List View', authenticate: true }, props: true},
                    { path: 'map/', name: 'account.scans.search.map', component: () => import('./page/scan/search/MapPage.vue'), meta: {title: 'Map View', authenticate: true } },
                    { path: 'photo/', name: 'account.scans.search.photo', component: () => import('./page/scan/search/PhotoPage.vue'), meta: {title: 'Photo Grid', authenticate: true } },
                    { path: 'statistics/', name: 'account.scans.search.statistics', component: () => import('./page/scan/search/StatisticsPage.vue'), meta: {title: 'Statistics', authenticate: true } },
                ]
            },
            // { path: 'delete/', name: 'account.scans.bulk_scan', component: () => import('./page/scan/bulkScanRemoval/IndexPage.vue'), meta: {title: 'Bulk Scan Removal', authenticate: true}, children: [
            //         {path: '', name: 'account.scans.bulk_scan_removal', component: () => import('./page/scan/bulkScanRemoval/BulkRemovalScanPage.vue'), meta: {authenticate: true }}
            //     ], props: (route) => ({
            //         page: route.query.page, limit: route.query.limit, value: route.query.value, exact_value: route.query.exact_value, value_ci: route.query.value_ci,
            //         response: route.query.response, response_ci: route.query.response_ci, exact_response: route.query.exact_response, property_name: route.query.property_name,
            //         property_value: route.query.property_value, scan_ids: route.query.scan_ids, answer: route.query.answer, exact_answer: route.query.exact_answer,
            //         recent_scan: route.query.recent_scan, property: route.query.property, exact_property: route.query.exact_property, data_received: route.query.data_received,
            //         sort_order: route.query.sort_order, tz: route.query.tz, period: route.query.period, p_metric: route.query.p_metric, p_number: route.query.p_number,
            //         sort_by: route.query.sort_by, category: route.query.category, result: route.query.result, start_date: route.query.start_date, start_time: route.query.start_time,
            //         end_date: route.query.end_date, end_time: route.query.end_time, service_ids: route.query.service_ids, user_ids: route.query.user_ids, device_ids: route.query.device_ids,
            //         u_deleted: route.query.u_deleted, s_deleted: route.query.s_deleted, template: route.query.template
            //     })
            // },
            { path: 'edit/', name: 'account.scans.edit', component: ()=> import('./page/scan/EditScanPage.vue'), meta: {authenticate: true },
                props: (route) => ({scanId: route.query.scanId})
            },
        ]
    },
    { path: 'account/scans/uploads/', name: 'account.scans.uploads', component: () => import('./page/scan/UploadScanPage.vue'), meta: {title: 'Scan Uploads', authenticate: true },
        props: (route) => ({
            page: route.query.page, limit: route.query.limit, s: route.query.s, u: route.query.u, d: route.query.d,
            sd: route.query.sd, st: route.query.st, ed: route.query.ed, et: route.query.et, u_deleted: route.query.u_deleted, s_deleted: route.query.s_deleted
        })
    },
    {
        path: 'account/scans/templates/', name: 'account.scans.templates', redirect: { name: 'account.scans.templates.index' }, component: ()=> import('./page/scan/exportTemplate/IndexPage.vue'), meta: {title: 'Export Templates',authenticate: true },
        children: [
            { path: 'new/', name: 'account.scans.templates.new', component: ()=> import('./page/scan/exportTemplate/EditPage.vue'), props: (route) => ({ids: route.query.ids}), meta: {authenticate: true }},
            { path: ':templateID/', name: 'account.scans.templates.edit', component: ()=> import('./page/scan/exportTemplate/EditPage.vue'), meta: {authenticate: true } },
            { path: '', name: 'account.scans.templates.index', component: ()=> import('./page/scan/exportTemplate/ListPage.vue'), meta: {authenticate: true} }
        ]
    },
    { path: 'account/databases/', name: 'account.database', component: () => import('./page/database/DbIndexPage.vue'), meta: {title: 'Databases', authenticate: true, admin: true},
        children: [
            { path: 'new/', name: 'account.database.create', component: () => import('./page/database/DbCreatePage.vue'), meta: {authenticate: true }},
            { path: ':databaseId/', name: 'account.database.edit', component: () => import('./page/database/DbEditPage.vue'), meta: {authenticate: true },
                children: [
                    { path: 'search/', name: 'account.database.edit_search', component: () => import('./page/database/DbEditSearchPage.vue'),
                        props: (route) => ({
                            page: route.query.page,
                            limit: route.query.limit,
                            preview: route.query.preview
                        }), meta: {authenticate: true }
                    },
                    { path: '', name: 'account.database.add_value', component: () => import('./page/database/DbAddValuePage.vue'), meta: {authenticate: true }},
                    { path: 'manage/', name: 'account.database.import', component: () => import('./page/database/DbImportValuePage.vue'), meta: {authenticate: true }},
                    { path: 'autofill/', name: 'account.database.autofill', component: () => import('./page/database/DbAutofillPage.vue'), meta: {authenticate: true }},
                    { path: 'clear/', name: 'account.database.clear', component: () => import('./page/database/DbClearPage.vue'), meta: {authenticate: true }},
                    { path: 'record/', name: 'account.database.record', component: () => import('./page/database/AppDatabaseRecordPage.vue'), meta: {authenticate: true }},
                    { path: 'record/upload/', name: 'account.database.record.upload', component: () => import('./page/database/DatabaseRecordUploadPage.vue'), meta: {authenticate: true }},
                ]
            },
            {
                path: '', name: 'account.database.index', component: () => import('./page/database/DbListPage.vue'),
                props: (route) => ({
                    page: route.query.page,
                    limit: route.query.limit,
                    search: route.query.search,
                    sortby: route.query.sortby,
                    sortdirection: route.query.sortdirection
                }), meta: {authenticate: true }
            }
        ]
    },
    {
        path: 'account/questions/', name: 'account.question', component: () => import('./page/question/QuestionPage.vue'), meta: {title: 'Questions', authenticate: true, admin: true},
        children: [
            {
                path: '', name: 'account.question.index', component: () => import('./page/question/IndexPage.vue'),
                props: (route) => ({
                    page: route.query.page,
                    limit: route.query.limit,
                    search: route.query.search,
                    searchType: route.query.searchType,
                    sortby: route.query.sortby,
                    sortdirection: route.query.sortdirection
                }), meta: {authenticate: true}
            },
            { path: 'new/', name: 'account.question.create', component: () => import('./page/question/CreatePage.vue'), meta: {authenticate: true}},
            { path: ':questionId/', name: 'account.question.edit', component: ()=> import('./page/question/EditPage.vue'), meta: {authenticate: true } }
            // { path: 'new/', name: 'account.question.create', component: () => import('./page/question/CreatePage.vue'), meta: {authenticate: true}},
            // { path: ':questionId/', name: 'account.question.edit', component: ()=> import('./page/question/EditPage.vue'), meta: {authenticate: true } }
        ]
    },
    { path: 'account/users/', name: 'account.user', component: () => import('./page/user/UserPage.vue'), meta: {title: 'Users', authenticate: true, admin: true},
        children: [
            { path: '', name: 'account.user.index', component: () => import('./page/user/IndexPage.vue'),
                props: (route) => ({
                    page: route.query.page || 1,
                    limit: route.query.limit || 50,
                    search: route.query.search || '',
                    sortby: route.query.sortby || '',
                    sortdirection: route.query.sortdirection || ''
                }),
                meta: {authenticate: true }
            },
            { path: 'new/', name: 'account.user.create', component: () => import('./page/user/CreatePage.vue') , meta: {authenticate: true } },
            { path: ':userId/', name: 'account.user.edit', component: () => import('./page/user/EditPage.vue'), meta: {authenticate: true } },
        ]
    },
    { path: 'account/tasks/', name: 'account.task', component: () => import('./page/task/IndexPage.vue'), meta: {title: 'Tasks', authenticate: true, admin: true},
        children: [
            { path: 'new', name: 'account.taskcreate.index', component: () => import('./page/task/CreatePage.vue'), meta: {authenticate: true }},
            { path: 'downloaddatabase', name: 'account.task.downloaddb', component: () => import('./page/task/downloadDatabase/IndexPage.vue'), meta: {authenticate: true },
                children: [
                    {
                        path: '',
                        name: 'account.taskcreate.downloaddb',
                        component: () => import('./page/task/downloadDatabase/CreatePage.vue'),
                        meta: {authenticate: true }
                    },
                    {
                        path: ':id/',
                        name: 'account.taskedit.downloaddb',
                        component: () => import('./page/task/downloadDatabase/EditPage.vue'),
                        meta: {authenticate: true }
                    }
                ]
            },
            { path: 'downloadscan/', name: 'account.task.downloadscan', component: () => import('./page/task/downloadScan/IndexPage.vue'), meta: {authenticate: true },
                children: [
                    {
                        path: '',
                        name: 'account.taskcreate.downloadscan',
                        component: () => import('./page/task/downloadScan/CreatePage.vue'), meta: {authenticate: true }
                    },
                    {
                        path: ':id/',
                        name: 'account.taskedit.downloadscan',
                        component: () => import('./page/task/downloadScan/EditPage.vue'), meta: {authenticate: true }
                    }
                ]
            },
            { path: 'generatebarcode/', name: 'account.task.generatebarcode', component: () => import('./page/task/exportBarcode/IndexPage.vue'), meta: {authenticate: true },
                children: [
                    {
                        path: '',
                        name: 'account.taskcreate.generatebarcode',
                        component: () => import('./page/task/exportBarcode/CreatePage.vue'), meta: {authenticate: true }
                    },
                    {
                        path: ':id/',
                        name: 'account.taskedit.generatebarcode',
                        component: () => import('./page/task/exportBarcode/EditPage.vue'), meta: {authenticate: true }
                    }
                ]
            },
            { path: 'exportscan/', name: 'account.task.exportscan', component: () => import('./page/task/exportScan/IndexPage.vue'), meta: {authenticate: true },
                children: [
                    {
                        path: '',
                        name: 'account.taskcreate.exportscan',
                        component: () => import('./page/task/exportScan/CreatePage.vue'), meta: {authenticate: true }
                    },
                    {
                        path: ':id/',
                        name: 'account.taskedit.exportscan',
                        component: () => import('./page/task/exportScan/EditPage.vue'), meta: {authenticate: true }
                    }
                ]
            },
            { path: 'clearDatabase/', name: 'account.task.clearDatabase', component: () => import('./page/task/clearDatabase/IndexPage.vue'), meta: {authenticate: true },
                children: [
                    {
                        path: '',
                        name: 'account.taskcreate.clearDatabase',
                        component: () => import('./page/task/clearDatabase/CreatePage.vue'), meta: {authenticate: true }
                    },
                    {
                        path: ':id/',
                        name: 'account.taskedit.clearDatabase',
                        component: () => import('./page/task/clearDatabase/EditPage.vue'), meta: {authenticate: true }
                    }
                ]
            },
            { path: 'importdatabase/', name: 'account.task.dbimportcsv', component: () => import('./page/task/importDatabase/IndexPage.vue'), meta: {authenticate: true },
                children: [
                    {
                        path: '',
                        name: 'account.taskcreate.dbimportcsv',
                        component: () => import('./page/task/importDatabase/CreatePage.vue'), meta: {authenticate: true }
                    },
                    {
                        path: ':id/',
                        name: 'account.taskedit.dbimportcsv',
                        component: () => import('./page/task/importDatabase/EditPage.vue'), meta: {authenticate: true }
                    }
                ]
            },
            { path: 'bulkscanremoval/', name: 'account.task.bulkscanremoval', component: () => import('./page/task/bulkScanRemoval/IndexPage.vue'), meta: {authenticate: true },
                children: [
                    {
                        path: '',
                        name: 'account.taskcreate.bulkscanremoval',
                        component: () => import('./page/task/bulkScanRemoval/CreatePage.vue'), meta: {authenticate: true }
                    },
                    {
                        path: ':id/',
                        name: 'account.taskedit.bulkscanremoval',
                        component: () => import('./page/task/bulkScanRemoval/EditPage.vue'), meta: {authenticate: true }
                    }
                ]
            },
            { path: 'importuser/', name: 'account.task.importuser', component: () => import('./page/task/importUser/IndexPage.vue'), meta: {authenticate: true },
                children: [
                    {
                        path: '',
                        name: 'account.taskcreate.importuser',
                        component: () => import('./page/task/importUser/CreatePage.vue'), meta: {authenticate: true }
                    },
                    {
                        path: ':id/',
                        name: 'account.taskedit.importuser',
                        component: () => import('./page/task/importUser/EditPage.vue'), meta: {authenticate: true }
                    }
                ]
            },
            { path: 'exportuser/', name: 'account.task.exportuser', component: () => import('./page/task/exportUser/IndexPage.vue'), meta: {authenticate: true },
                children: [
                    {
                        path: '',
                        name: 'account.taskcreate.exportuser',
                        component: () => import('./page/task/exportUser/CreatePage.vue'), meta: {authenticate: true }
                    }
                ]
            },
            { path: 'postback/', name: 'account.task.postback', component: () => import('./page/task/postbackScan/IndexPage.vue'), meta: {authenticate: true },
                children: [
                    {
                        path: '',
                        name: 'account.taskcreate.postback',
                        component: () => import('./page/task/postbackScan/CreatePage.vue'), meta: {authenticate: true }
                    },
                    {
                        path: ':id/',
                        name: 'account.taskedit.postback',
                        component: () => import('./page/task/postbackScan/EditPage.vue'), meta: {authenticate: true }
                    }
                ]
            },
            {
                path: 'listing', name: 'account.task.listing', component: () => import('./page/task/ListingPage.vue'), meta: {authenticate: true },
                children: [
                    {
                        path: 'scheduled',
                        name: 'account.task.listing.scheduled',
                        component: () => import('./page/task/schedule/IndexPage.vue'), meta: {authenticate: true }
                    },
                    {
                        path: 'notifications',
                        name: 'account.task.listing.notifications',
                        component: () => import('./page/task/notifications/IndexPage.vue'), meta: {authenticate: true }
                    },
                    {
                        path: 'instance',
                        name: 'account.task.listing.instance',
                        component: () => import('./page/task/instance/IndexPage.vue'), meta: {authenticate: true }
                    },
                    {   path: 'tasklog',
                        name: 'account.task.listing.tasklog',
                        component: () => import('./page/task/LogPage.vue') , meta: {authenticate: true }
                    },
                ]
            },
            // { path: 'attendancereport/', name: 'account.task.attendancereport', component: AppAccountTaskPostbackScanPage, meta: {authenticate: true },
            //     children: [
            //         {
            //             path: '',
            //             name: 'account.taskcreate.attendancereport',
            //             component: AppAttendanceReportCreatePage, meta: {authenticate: true }
            //         },
            //         {
            //             path: ':id/',
            //             name: 'account.taskedit.attendancereport',
            //             component: AppAttendanceReportEditPage, meta: {authenticate: true }
            //         }
            //     ]
            // },
            { path: 'downloadcheckinout/', name: 'account.task.downloadcheckinout', component: () => import('./page/task/downloadCheckInOut/IndexPage.vue'), meta: {authenticate: true },
                children: [
                    {
                        path: '',
                        name: 'account.taskcreate.downloadcheckinout',
                        component: () => import('./page/task/downloadCheckInOut/CreatePage.vue'), meta: {authenticate: true }
                    },
                    {
                        path: ':id/',
                        name: 'account.taskedit.downloadcheckinout',
                        component: () => import('./page/task/downloadCheckInOut/EditPage.vue'), meta: {authenticate: true }
                    }
                ]
            },
            { path: 'downloaddevices/', name: 'account.task.downloaddevices', component: () => import('./page/task/downloadDevices/IndexPage.vue'), meta: {authenticate: true },
                children: [
                    {
                        path: '',
                        name: 'account.taskcreate.downloaddevices',
                        component: () => import('./page/task/downloadDevices/CreatePage.vue'), meta: {authenticate: true }
                    },
                    {
                        path: ':id/',
                        name: 'account.taskedit.downloaddevices',
                        component: () => import('./page/task/downloadDevices/EditPage.vue'), meta: {authenticate: true }
                    }
                ]
            },
            { path: 'importcheckinoutscans/', name: 'account.task.importcheckinoutscans', component: () => import('./page/task/importCheckInOutScan/IndexPage.vue'), meta: {authenticate: true },
                children: [
                    {
                        path: '',
                        name: 'account.taskcreate.importcheckinoutscans',
                        component:  () => import('./page/task/importCheckInOutScan/CreatePage.vue'), meta: {authenticate: true }
                    },
                    {
                        path: ':id/',
                        name: 'account.taskedit.importcheckinoutscans',
                        component:  () => import('./page/task/importCheckInOutScan/EditPage.vue'), meta: {authenticate: true }
                    }
                ]
            },
            { path: 'importtablebuilderscans/', name: 'account.task.importtablebuilderscans', component: () => import('./page/task/importTableBuilderScans/IndexPage.vue'), meta: {authenticate: true },
                children: [
                    {
                        path: '',
                        name: 'account.taskcreate.importtablebuilderscans',
                        component:  () => import('./page/task/importTableBuilderScans/CreatePage.vue'), meta: {authenticate: true }
                    },
                    {
                        path: ':id/',
                        name: 'account.taskedit.importtablebuilderscans',
                        component:  () => import('./page/task/importCheckInOutScan/EditPage.vue'), meta: {authenticate: true }
                    }
                ]
            },
            { path: 'importtable/', name: 'account.task.importtable', component: () => import('./page/task/importTable/IndexPage.vue'), meta: {authenticate: true },
                children: [
                    {
                        path: '',
                        name: 'account.taskcreate.importtable',
                        component:  () => import('./page/task/importTable/CreatePage.vue'), meta: {authenticate: true }
                    },
                    /*{
                        path: ':id/',
                        name: 'account.taskedit.importtablescans',
                        component:  () => import('./page/task/importCheckInOutScan/EditPage.vue'), meta: {authenticate: true }
                    }*/
                ]
            },
            { path: 'progress/:instanceId', name: 'account.task.progress', component: () => import('./page/task/ProgressPage.vue'), meta: {authenticate: true } }
        ]
    },
    { path: 'account/userprofile/', name: 'account.userprofile', component: () => import('./page/account/userProfile/IndexPage.vue'), meta: {title: 'User Profile', authenticate: true, privilege: 'user'}},
    { path: 'account/settings/', name: 'account.setting', component: () => import('./page/account/settings/SettingPage.vue'), meta: {title: 'Setting', authenticate: true, privilege: 'webapp_login', admin: true}, children:[
            { path: '', name: 'account.setting.general', component: () => import('./page/account/settings/GeneralPage.vue'), meta: {authenticate: true , title: 'General'} },
        ]},
    { path: 'account/links/', name: 'account.shorturl', component: () => import('./page/account/shortUrl/ShortUrlPage.vue'), meta: {title: 'Share Links', authenticate: true},
        children: [
            { path: '', name: 'account.shorturl.index', component: () => import('./page/account/shortUrl/IndexPage.vue'), meta: {authenticate: true} },
            { path: ':shorturlId/', name: 'account.shorturl.edit', component: () => import('./page/account/shortUrl/EditPage.vue'), meta: {authenticate: true} }
        ]
    },
    { path: 'account/billing/', name: 'account.billing', component: () => import('./page/account/billing/IndexPage.vue'), meta: {title: 'Billing', authenticate: true, privilege: 'billing' }, children: [
            { path: '', name: 'account.billing.overview', component: () => import('./page/account/billing/OverviewPage.vue'), meta: {authenticate: true , title: 'Overview'} },
            { path: 'business/', name: 'account.billing.business', component: () => import('./page/account/billing/BusinessPage.vue'), meta: {authenticate: true , title: 'Business Details'} },
            { path: 'invoices/', name: 'account.billing.invoices', component: () => import('./page/account/billing/InvoicePage.vue'), meta: {authenticate: true , title: 'Invoices'} },
            { path: 'creditcards/', name: 'account.billing.creditcards', component: () => import('./page/account/billing/CreditCardPage.vue'), meta: {authenticate: true, title: 'Credit Cards' } },
        ]
    },
    { path: 'account/admins/', name: 'account.admins', component: () => import('./page/account/administration/IndexPage.vue'), meta: {title: 'Admins', authenticate: true},
        children: [
            {path: 'create/', name: 'account.admins.create', component: () => import('./page/account/administration/CreateAdminPage.vue'), meta: {title: 'Create Admin', authenticate: true, modalCreate: true}},
            {path: ':accountId/', name: 'account.admins.edit', component: () => import('./page/account/administration/EditAdminPage.vue'), meta: {title: 'Edit Admin', authenticate: true, modalEdit: true}}
        ]
    },

    { path: 'account/deleteaccount/', name: 'account.deleteaccount', component: () => import('./page/account/settings/DeleteAccountPage.vue'), meta: {title: 'Account', authenticate: true, owner: true}},

    { path: 'account/myplan/', name: 'account.myplan', component: () => import('./page/account/plan/MyPlanPage.vue'), meta: {title: 'Plan', authenticate: true, privilege: 'billing'}},
    { path: 'account/plans/', name: 'account.plans', component: () => import('./page/account/plan/PlansPage.vue'), meta: {title: 'Plans - CodeREADr', authenticate: true, privilege: 'billing'}},
    { path: 'account/upgradesuccess/', name: 'account.plan.success', component: () => import('./page/account/plan/PlanChangeSuccessPage.vue'), meta: {authenticate: true, title: 'Plan Success', privilege: 'billing' } },
    /*
        { path: 'account/thankyou/', name: 'account.thankyou', component: () => import('./page/account/plan/ThankYouPage.vue'), meta: {title: 'Thank You', authenticate: true, privilege: 'billing'}},
    */
    {
        path:'account/change-plan-upgrade',
        name:'account.change.plan.upgrade',
        component: () => import ('./page/account/plan/SavePlanPage.vue'),
        meta : {
            authenticate: true,
            privilege: 'billing',
            title: 'Change Plan - Upgrade - CodeREDr',
        }
    },
    {
        path:'account/change-plan-schedule-downgrade',
        name:'account.change.plan.schedule.downgrade',
        component: () => import ('./page/account/plan/SavePlanPage.vue'),
        meta : {
            authenticate: true,
            privilege: 'billing',
            title: 'Change Plan - Schedule Downgrade - CodeREDr',
        }
    },
    {
        path:'account/change-plan-schedule-upgrade',
        name:'account.change.plan.schedule.upgrade',
        component: () => import ('./page/account/plan/SavePlanPage.vue'),
        meta : {
            authenticate: true,
            privilege: 'billing',
            title: 'Change Plan - Schedule Upgrade - CodeREDr'
        }
    },
    { path: 'account/change-plan/', name: 'account.saveplan', component: ()=> import('./page/account/plan/SavePlanPage.vue'), meta: {title: 'Change Plan - CodeREADr', authenticate: true, privilege: 'billing'}},
    { path: 'account/api/', name: 'account.api', component:() => import('./page/account/api/IndexPage.vue'), meta: {title: 'API', authenticate: true},
        children: [
            { path: '', redirect: 'key', name:'account.api.index'},
            { path: 'key', name: 'account.api.keys', component:() => import('./page/account/api/ApiKeys.vue'), meta: {authenticate: true, title: 'Key'}},
            { path: 'ipwhitelist', name: 'account.api.apiwhitelist', component: () => import('./page/account/api/WhiteListPage.vue'), meta: {authenticate: true, title:'IP Whitelist'}},
            { path: 'apilog', name: 'account.api.apilog', component: () => import('./page/account/api/ApiLogPage.vue'), meta: {authenticate: true, title: 'Logs'}}
        ]},
    { path: 'account/customize/', name: 'account.customize', component: () => import('./page/account/branding/IndexPage.vue'), meta: {title: 'Branding', authenticate: true}},
    { path: 'account/external-account/dropbox-return/', name: 'account.externalaccount.returndropbox', component: () => import('./page/account/externalAccount/ReturnDropboxPage.vue'),
        props: (route) => ({
            code: route.query.code,
            state: route.query.state,
            error: route.query.error,
            error_description: route.query.error_description,
        })
    },
    { path: 'account/external-account/box-return/', name: 'account.externalaccount.boxreturn', component: () => import('./page/account/externalAccount/ReturnBoxPage.vue'),
        props: (route) => ({
            code: route.query.code,
            state: route.query.state,
            error: route.query.error,
            error_description: route.query.error_description,
        })
    },
    { path: 'account/external-account/google-return/', name: 'account.externalaccount.googlereturn', component: () => import('./page/account/externalAccount/ReturnGooglePage.vue'),
        props: (route) => ({
            code: route.query.code,
            state: route.query.state,
            error: route.query.error,
            error_description: route.query.error_description,
        })
    },
    { path: 'account/integrations/', component: () => import('./page/account/externalAccount/IndexPage.vue'), meta: {title: 'Integrations', authenticate: true},
        children: [
            {path: '', redirect: 'postback', name: 'account.externalaccount',},
            {path: 'postback', name: 'account.externalaccount.postback', component: () => import('./page/account/externalAccount/PostbackPage.vue'), meta: {authenticate: true, title : 'Postback'} },
            {path: 'file-storage', name: 'account.externalaccount.filestorage', component: () => import('./page/account/externalAccount/FileStoragePage.vue'), meta: {authenticate: true,  title : 'File Storage' } },
            {path: 'zapier', name: 'account.externalaccount.zapier', component: () => import('./page/account/externalAccount/ZapierPage.vue') , meta: {authenticate: true, title : 'Zapier' } },
            {path: 'single-sign-on', name: 'account.externalaccount.singlesingnon', component: () => import('./page/account/externalAccount/SingleSignOnPage.vue') , meta: {authenticate: true, title : 'Single Sign On' } },
            {path: 'make', name: 'account.externalaccount.make', component: () => import('./page/account/externalAccount/MakePage.vue'), meta: {authenticate: true , title : 'Make'} },
        ]
    },
    { path: 'account/postbacktool/', name: 'account.postbacktool', component: () => import('./page/account/api/PostbackToolPage.vue'), meta: {title: 'Postback Tool'}},
    { path: 'account/devices/', name: 'account.devices', component: () => import('./page/account/device/IndexPage.vue'), meta: {title: 'Devices', authenticate: true}},
    { path: 'account/changepassword/', name: 'account.changepassword', component: () => import('./page/account/settings/ChangePasswordPage.vue'), meta: {title: 'Account', authenticate: true, owner: true}},
    { path: 'resetpassword/:token/', name: 'security.resetpassword', component: () => import('./page/account/settings/ResetPasswordPage.vue'), meta: { authenticate: false, title: 'Reset Password' } },
    { path: 'user/confirmemail/:role?/:token/', name: 'security.user.confirmemail', component: () => import('./page/account/settings/UserConfirmEmailPage.vue'), meta: { authenticate: false, title: 'Confirm Email' } },
    { path: '/:pathMatch(.*)*', name: 'notfound', component: () => import('./page/notFound/PageNotFound.vue') }
];


const routes: RouteRecordRaw[] = [
    {
        path: '/',
        redirect: () => window.location.href = '/signin',
        component: () => import('./page/AppPage.vue'),
        children: [...otherRoutesChildren]
    },
    {
        path: '/verify-email',
        name: 'security.verify-email',
        component: () => import('./page/security/email-verification/VerifyEmailPage.vue'),
        meta: { authenticate: false, title: 'Smart Barcode Scanner App for Businesses - CodeREADr' },
        props: (route) => ({ email: route.query.email })
    },
    {
        path: '/confirm-multi-account',
        name: 'security.confirm-multi-account',
        component: () => import('./page/security/multi-account/ConfirmMultiAccountPage.vue'),
        meta: { authenticate: false, title: 'Smart Barcode Scanner App for Businesses - CodeREADr' },
        props: (route) => ({ email: route.query.email })
    },
    {
        path: '/app-custom',
        name: 'security.app-custom',
        component: () => import('./page/security/utilities/LookupTableViewPage.vue'),
        meta: { authenticate: false, title: 'Smart Barcode Scanner App for Businesses - CodeREADr' },
        props: (route) => ({ tableId: route.query.tableId })
    },
    {
        path: '/registration',
        name: 'security.registration',
        component: () => import('./page/security/auth/RegistrationPage.vue'),
        meta: { authenticate: false, title: 'Smart Barcode Scanner App for Businesses - CodeREADr' }
    },
    {
        path: '/app-contact',
        name: 'security.app-contact',
        component: () => import('./page/security/support/AppContactPage.vue'),
        meta: { authenticate: false, title: 'codeREADr' }
    },
    {
        path: '/activation/:token/',
        name: 'security.activation',
        component: () => import('./page/security/email-verification/ActivationPage.vue'),
        meta: { authenticate: false, title: 'Smart Barcode Scanner App for Businesses - CodeREADr' },
    },
    {
        path: '/signin',
        name: 'security.signin',
        component: () => import('./page/security/auth/SigninPage.vue'),
        meta: { authenticate: false, title: 'Smart Barcode Scanner App for Businesses - CodeREADr' },
        props: (route) => ({ to: route.query.to, company: route.query.company })
    },
    {
        path: '/select-company',
        name: 'security.select-company',
        component: () => import('./page/security/multi-account/SelectCompanyPage.vue'),
        meta: { authenticate: false, title: 'Smart Barcode Scanner App for Businesses - CodeREADr' }
    },
    {
        path: '/signinSSO',
        name: 'security.signinSSO',
        component: () => import('./page/security/auth/SigninSSOPage.vue'),
        meta: { authenticate: false, title: 'Smart Barcode Scanner App for Businesses - CodeREADr' },
        props: (route) => ({ code: route.query.code, error: route.query.error })
    },
    {
        path: '/signin-company',
        name: 'security.signin-company',
        component: () => import('./page/security/multi-account/SigninCompanyPage.vue'),
        meta: { authenticate: false, title: 'Smart Barcode Scanner App for Businesses - CodeREADr' }
    },
    {
        path: '/pick-interest',
        name: 'security.pick-interest',
        component: () => import('./page/security/onboarding/PickInterestPage.vue'),
        meta: { authenticate: true, title: 'CodeREADr' }
    },
    {
        path: '/forgotpassword',
        name: 'security.forgotpassword',
        component: () => import('./page/security/auth/ForgotPasswordPage.vue'),
        meta: { authenticate: false, title: 'Smart Barcode Scanner App for Businesses - CodeREADr'},
    },
    {
        path: '/forgotpassword/reset',
        name: 'security.forgotpassword.reset',
        component: () => import('./page/security/auth/ForgotPasswordResetSuccessPage.vue'),
        meta: { authenticate: false, title: 'Smart Barcode Scanner App for Businesses - CodeREADr' }
    },
    {
        path: '/device-lookup',
        name: 'security.device-lookup',
        component: () => import('./page/security/utilities/LookupTableViewPage.vue'),
        meta: { authenticate: false, title: 'Smart Barcode Scanner App for Businesses - CodeREADr' },
        props: (route) => ({ tableId: route.query.tableId, deviceId: route.query.deviceId })
    },
    {
        path: '/share-link',
        name: 'security.share-link',
        component: () => import('./page/security/utilities/ShareLinkTaskProgressPage.vue'),
        meta: { authenticate: false, title: 'Share Link' },
        props: (route) => ({ taskId: route.query.taskId, token: route.query.token })
    },
    {
        path: '/google-auth',
        name: 'security.google-auth',
        component: () => import('./page/security/auth/GoogleAuthPage.vue'),
        meta: { authenticate: false, title: 'Smart Barcode Scanner App for Businesses - CodeREADr' },
        props: (route) => ({ code: route.query.code, error: route.query.error })
    },
    {
        path: '/password-reset-success',
        name: 'security.password-reset-success',
        component: () => import('./page/security/auth/ForgotPasswordResetSuccessPage.vue'),
        meta: { authenticate: false, title: 'Smart Barcode Scanner App for Businesses - CodeREADr' }
    },
    {
        path: '/share-link-expired',
        name: 'security.share-link-expired',
        component: () => import('./page/security/utilities/ShareLinkExpirePage.vue'),
        meta: { authenticate: false, title: 'Share Link' }
    },
    { path: '/scanresponse/:scanId/', name: 'app.scanresponse', component: import('./page/scan/ResponsePage.vue'), meta: {authenticate: false }},
    { path: '/checkinout/', name: 'CheckInOutPortal', component: () => import('./page/portal/checkInOut/IndexPage.vue'), meta: { authenticate: false, title: 'Check In/Out',
            props: (route) => ({
                instance_id: route.query.instance_id
            }),
        },
        children: [
            { path: 'signin/:aliasOrAdminId?', name: 'CIOPLogin', component: () => import('./page/portal/checkInOut/LoginPage.vue'), meta: { authenticate: false },
            },
            { path: 'signin-company/', name: 'CIOPCompanyLogin', component: () => import('./page/portal/checkInOut/LoginCompanyPage.vue'), meta: { authenticate: false },
            },
            { path: '', name: 'CIOPTemplate', component: () => import('./page/portal/checkInOut/TemplatePage.vue'), meta: { authenticate: false },
                children: [
                    { path: '', name: 'CIOPTemplateIndex', component: () => import('./page/portal/checkInOut/TemplateIndexPage.vue'), meta: { authenticate: false },
                    },
                ]
            },
            { path: 'valueresponse/', name: 'CIOPValueResponse', component: () => import('./page/portal/checkInOut/ValueResponsePage.vue'), meta: { authenticate: false },
            },
        ]
    },
    { path: '/task-portal/', name: 'taskPortal', component: ()=> import('./page/portal/taskPortal/IndexPage.vue'), meta: { authenticate: false, title: 'Task Portal' },
        props: (route) => ({ q: route.query.q, page: route.query.page, limit: route.query.limit }),
        children: [
            { path: '', name: 'TPLogin', component:()=> import('./page/portal/taskPortal/LoginPage.vue'), meta: { authenticate: false },
                props: (route) => ({
                    errCode: route.query.errCode,
                }),},
            { path: 'tasks/', name: 'TPCsv', component: () => import('./page/portal/taskPortal/TaskPage.vue'), meta: { authenticate: false }},
        ]
    },
    { path: '/share/preview/', name: 'UPortal', component: ()=> import('./page/portal/user/IndexPage.vue'), meta: { authenticate: false, title: 'User Portal' },
        props: (route) => ({ q: route.query.q, page: route.query.page, limit: route.query.limit }),
        children: [
            { path: '', name: 'UPLogin', component:()=> import('./page/portal/user/LoginPage.vue'), meta: { authenticate: false },
                props: (route) => ({
                    errCode: route.query.errCode,
                }),},
            { path: 'account/login-company/', name: 'UPCompanyLogin', component: () => import('./page/portal/user/LoginCompanyPage.vue'), meta: { authenticate: false }
            },
            { path: 'scans/', name: 'UPScans', component: () => import('./page/portal/user/ScansPage.vue'), meta: { authenticate: false },
                props: (route) => ({
                    expandeds: route.query.expandeds,
                    start: route.query.start,
                    end: route.query.end,
                    search: route.query.search
                }),
            },
            { path: 'db/', name: 'UPDbValues', component: ()=> import('./page/portal/user/DatabaseValuesPage.vue'), meta: { authenticate: false },
                props: (route) => ({
                    duplicateType: route.query.duplicateType,
                    value: route.query.value,
                    valueCi: route.query.valueCi,
                    exactValue: route.query.exactValue,
                    response: route.query.response,
                    exactResponse: route.query.exactResponse,
                    responseCi: route.query.responseCi,
                })
            },
        ]},

    {
        path: '/sso-fail/', name: 'Sso-fail', component: () => import('./page/portal/SsoFail.vue'), meta: { authenticate: false, title: 'SSO fail' }
    },

    { path: '/app/1.0/more/sd-pro', name: 'app.sd_pro', component: () => import('./page/SDproInfo/IndexPage.vue'), meta: { authenticate: false, title: 'SD PRO Scan Engine' }},
    { path: '/crapp/scan/edit/', name: 'crapp.edit_scan', component: () => import('./page/scan/EditIsolatePage.vue'), meta: { authenticate: false, title: 'Edit Scan' }},
    { path: '/apidocs/examples/csv2db.html', name: 'examplesCsv2db', component: () => import('./page/ExampleApiDocsCsv2db/IndexPage.vue'), meta: { authenticate: false, title: 'CSV to Database' } },
    { path: '/app/1.0/mapview/', name: 'app.mapview', component: () => import('./page/App/MapView/IndexPage.vue'), meta: { authenticate: false, title: 'Map View' }}
];

const router:any = createRouter({
    history: createWebHistory(),
    routes,
    linkActiveClass: 'active',
    scrollBehavior() {
        document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
    }
});

router.beforeEach(async (to, from, next) => {
    if (window.location.search.match(/%&|%$/)) {
        const qs = window.location.search
            .replace(/%&/, "%25&")
            .replace(/%$/, "%25");
        // Using vue router to redirect ends up in an infinite loop
        window.location.href = window.location.pathname + qs;
        return;
    }
    let listRouteSignOut = ['security.activation','security.user.confirmemail'];
    if (to && listRouteSignOut.includes(to.name)) {
        await SecurityService.signOut();
    }
    const isAuthenticated = SecurityService.isAuthenticated();
    let nearestWithAuthentication = to.matched.slice().reverse().find(r => r.meta && r.meta.authenticate);
    if (nearestWithAuthentication && nearestWithAuthentication.meta.authenticate && !isAuthenticated) {
        window.location.href="/signin/?to="+to.fullPath;
        /* next({
             name: 'security.signin',
             query: {to: to.fullPath}
         });*/
    } else {
        await SecurityService.getUser();
        let unauthorized = false;
        let nearestWithOwner = to.matched.slice().reverse().find(r => r.meta && r.meta.owner);
        const isOwner = SecurityService.isOwner();
        if (nearestWithOwner && nearestWithOwner.meta.owner && !isOwner) {
            unauthorized = true;
        }
        let nearestWithAdmin = to.matched.slice().reverse().find(r => r.meta && r.meta.admin);
        const user = await SecurityService.me()
        if (user && !['owner', 'billing_admin', 'admin'].includes(user.accountUser.role[0]) && nearestWithAdmin && nearestWithAdmin.meta.admin) {
            unauthorized = true;
        }

        let nearestWithPrivilege = to.matched.slice().reverse().find(r => r.meta && r.meta.privilege);
        if (nearestWithPrivilege) {
            let privilege = nearestWithPrivilege.meta.privilege;
            if (privilege !== 'user') {
                const hasPrivilege = SecurityService.hasPrivilege(privilege);
                if (!hasPrivilege) {
                    unauthorized = true;
                }
            }
        }
        if (unauthorized) {
            next({
                name: 'app.unauthorized',
            });
        }
        let nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

        let title = 'Barcode Scanning, Recording, Validation App';
        if (nearestWithTitle) {
            title = String(nearestWithTitle.meta.title);
        }
        document.title = to.meta.title;
        next()
    }
});
export default router;
